import { render, staticRenderFns } from "./BpsMainNavigation.vue?vue&type=template&id=c79286e2&scoped=true&"
import script from "./BpsMainNavigation.vue?vue&type=script&lang=ts&"
export * from "./BpsMainNavigation.vue?vue&type=script&lang=ts&"
import style0 from "./BpsMainNavigation.vue?vue&type=style&index=0&id=c79286e2&prod&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c79286e2",
  null
  
)

export default component.exports